import React, { FC, useContext } from 'react'
import { CompanyNode } from '@src/generated/schema'
import { useTranslation } from 'react-i18next'
import { StyledPopover, StyledPopoverOption } from './PopoverRow.styles'
import { ModalEnum } from '../List'
import { MeContext, Permissions } from '@src/components/Providers'

export interface PopoverRowProps {
  company: CompanyNode
  toggleModal: (modalType: ModalEnum, company: CompanyNode) => void
}

export const PopoverRow: FC<PopoverRowProps> = ({ toggleModal, company }) => {
  const { t } = useTranslation()
  const { userHasPermission, me } = useContext(MeContext)

  return (
    <StyledPopover>
      <StyledPopoverOption onClick={() => toggleModal(ModalEnum.SHOW, company)}>
        {t('desktop.pages.companies.list.popover.show')}
      </StyledPopoverOption>
      {userHasPermission(Permissions.CAN_CHANGE_COMPANY) && me?.client?.canChangePlotPile && (
        <StyledPopoverOption onClick={() => toggleModal(ModalEnum.CHANGE, company)}>
          {t('desktop.pages.companies.list.popover.edit')}
        </StyledPopoverOption>
      )}
    </StyledPopover>
  )
}
